export function plural($cnt, $words){

    if($cnt == 1){
        return $words[0];
    }else if($cnt < 5 && $cnt > 0){
        return $words[1]
    }else{
        return $words[2]
    }
}